import LineUserIcon from 'LuxKit/Icons/line/LineUserIcon'
import Label from 'LuxKit/Label'
import React from 'react'
import { useIntl } from 'react-intl'

interface Props {
  name: string
}

function MultiCartAddedByLabel({ name }: Props) {
  const intl = useIntl()

  return <Label startIcon={<LineUserIcon />} kind="plain" variant="dark">
    {intl.formatMessage(
      {
        id: '6dbH7Cv8Ea',
        defaultMessage: 'Added by {name}',
        description: 'Label indicating which user added the cart item in the shopping cart',
      },
      { name },
    )}
  </Label>
}

export default MultiCartAddedByLabel
